import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => { if (user && user.email) nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
      setLoading(false);
    }
  };
  const cls = "w-full bg-white border border-white/20 rounded-sm px-4 py-3 font-light text-[#1A1918] focus:outline-none focus:border-[#B86B52] transition-colors";

  return (
    <div className="min-h-screen bg-[#0F2537] flex items-center justify-center px-6">
      <div className="w-full max-w-sm" data-testid="admin-login">
        <Link to="/" className="font-display text-2xl text-[#F6F4F0] block mb-2 tracking-[0.12em]">DERRON LUXURY</Link>
        <p className="overline text-[#B86B52] mb-8">Owner Portal</p>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="login-email" type="email" placeholder="Email" className={cls} value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="login-password" type="password" placeholder="Password" className={cls} value={password} onChange={(e) => setPassword(e.target.value)} />
          <button data-testid="login-submit" disabled={loading} className="w-full py-3.5 bg-[#B86B52] text-white rounded-sm tracking-wide hover:bg-[#a35c45] transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
